import React from "react";
import { useTranslation } from "react-i18next";
import PremiumHome from "./PremiumHome";
import homepageCopy from "../../content/homepage.json";

export default function Home() {
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || "hy";
  const messages = i18n.getResourceBundle(locale, "translation") || i18n.getResourceBundle("en", "translation");
  return <PremiumHome locale={locale} messages={messages} copy={homepageCopy[locale] || homepageCopy.en} links={{ contact: `/get-in-touch?lang=${locale}`, services: `/services?lang=${locale}`, portfolio: `/qr-menu-demo?lang=${locale}` }} />;
}
